import Swal from 'sweetalert2';

const brandConfirm = '#6d5ef9';
const brandCancel = '#94a3b8';

const toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: true,
});

export const notify = {
  info(title, text) {
    return Swal.fire({
      icon: 'info',
      title,
      text,
      confirmButtonColor: brandConfirm,
    });
  },

  success(title, text) {
    return toast.fire({
      icon: 'success',
      title: text ? `${title} — ${text}` : title,
    });
  },

  warning(title, text) {
    return Swal.fire({
      icon: 'warning',
      title,
      text,
      confirmButtonColor: brandConfirm,
    });
  },

  error(title, text) {
    return Swal.fire({
      icon: 'error',
      title,
      text,
      confirmButtonColor: brandConfirm,
    });
  },

  async confirm({
    title = 'Are you sure?',
    text,
    confirmButtonText = 'Continue',
    cancelButtonText = 'Cancel',
    icon = 'warning',
  } = {}) {
    const res = await Swal.fire({
      icon,
      title,
      text,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      confirmButtonColor: brandConfirm,
      cancelButtonColor: brandCancel,
      reverseButtons: true,
    });
    return res.isConfirmed;
  },
};

